import React, { useContext, useRef } from 'react';
import DotsVertical from '../../../Assets/OrderManagement/DotsVertical.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatDateToIST } from '../../../lib/utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import OrderKebabMenu from './OrderKebabMenu';
import { closeOrderKebabMenu, openOrderKebabMenu } from '../../../Features/orderManagementSlice';
import { useOutsideClickForTwoRef } from '../../../Hooks/useOutsideClickForTwoRef';
import { OrdersManagementContext } from '../../../Context/OrdersManagementContext';
import TickMark from '../../../Assets/Modals/TickMark.svg';
import { showToast } from '../../../Components/Toaster/Toaster';

function OrderListItem({ order, statusColors, orderStatus, payStatus, isSelected }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        dispatch(closeOrderKebabMenu());
    });

    const kebabOrderId = useSelector((state) => state.orderManagement.orderKebab.orderId);
    const { selectedOrders, setSelectedOrders } = useContext(OrdersManagementContext);

    const forwardToOrderDetailsPage = () => {
        navigate(`${location.pathname}/${order.orderId}`);
    }

    const handleOpenKebab = () => {
        if(kebabOrderId === order.orderId) {
            dispatch(closeOrderKebabMenu());
        }
        else {
            dispatch(openOrderKebabMenu(order.orderId));
        }
    }

    function handleSelectBoxClick() {
        if(selectedOrders.includes(order.orderId)) {
            const filteredList = selectedOrders.filter(item => item !== order.orderId);
            setSelectedOrders(filteredList);
        }
        else {
            setSelectedOrders([ ...selectedOrders, order.orderId ]);
        }
    }

    return (
        <div className="font-urbanist-regular border-t border-[#EAEAEA] flex items-center select-none">
            <div className="flex items-center gap-2 w-[22%] px-[10px] py-[6px] hover:bg-[linear-gradient(90deg,_rgba(245,245,245,1)_0%,_rgba(255,255,255,1)_100%)]">
                {
                    order.orderStatus === 'PENDING' ?  
                    <div onClick={handleSelectBoxClick} className={`cursor-pointer size-6 flex items-center justify-center rounded-md border ${isSelected ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                        <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                    </div> : 
                    <div onClick={() => { showToast('Please select a pending order.', 'warning') }} className="cursor-pointer size-6 bg-[#EAEAEA] rounded-md"></div>
                }

                <button onClick={forwardToOrderDetailsPage} className="outline-none w-[calc(100%-24px)] px-[10px] py-[26px]">
                    <h2 className='font-semibold text-[14px] leading-6 text-[#121212] text-left whitespace-nowrap overflow-hidden text-ellipsis'>#{order?.orderId?.slice(-6)}</h2>
                </button>
            </div>

            <div className="w-[22%] px-[10px] py-[26px]">
                <h2 className='font-semibold text-[14px] leading-6 text-[#121212] whitespace-nowrap overflow-hidden text-ellipsis'>{formatDateToIST(order.createdAt)}</h2>
            </div>

            <div className="w-[10%] px-[10px] py-[26px]">
                <h2 className='font-semibold text-[14px] leading-6 text-[#121212]'>{order.quantity ?? '1'}</h2>
            </div>

            <div className="w-[13.5%] px-[10px] py-[26px]">
                <h2 className='font-semibold text-[14px] leading-6 text-[#121212]'>₹{order.total}</h2>
            </div>

            <div className="w-[15%] px-[10px] py-[26px]">
                <h2 className={`font-semibold text-[14px] leading-6 ${payStatus}`}>
                    {order.paymentStatus}
                </h2>
            </div>

            <div className="w-[13.5%] px-[10px] py-[26px]">
                <h2 
                    className={`
                        w-fit font-urbanist-regular text-center font-medium text-[14px] leading-5 
                        px-3 py-[2px] rounded-xl 
                        ${statusColors}
                    `}
                >
                    {orderStatus}
                </h2>
            </div>

            <div className="w-[4%] px-[10px] py-[26px]">
                <div onClick={handleOpenKebab} ref={kebabButtonRef} className="cursor-pointer relative outline-none size-6 flex items-center justify-center">
                    <img src={DotsVertical} alt="" />

                    {
                        kebabOrderId === order.orderId && 
                        <OrderKebabMenu 
                            boxRef={kebabRef} 
                            order={order} 
                        />
                    }
                </div>
            </div>
        </div>
    );
}

export default OrderListItem;
